<script lang="ts">
	//Stores
	import { user_settings } from 'src/stores/account/user';
	//Services
	import { format } from '../../../../services/i18n';
	import {
		handleEmailPermissions,
		handlePushPermissions,
		handleNewsLetterPermissions,
	} from './user_permissions_helper';
	//Components
	import ConfirmEmail from '../../../ConfirmEmail.svelte';
	import NotificationToggler from './NotificationTogglerV2.svelte';
	//Design system compoennts
	import { Stack } from '@Shelly/shelly-design-system';
	//Helpers
	import { isSubUnit } from 'src/helpers/user_helpers';

	// Normalize newsletter value (-1 to 0)
	$: newsletterValue = $user_settings.newsletter === -1 ? 0 : $user_settings.newsletter;

	// Wrapper function to handle newsletter permissions
	const handleNewsletter = (value: number) => {
		handleNewsLetterPermissions(value === 1);
	};
</script>

<Stack class="notification-menu" gap="m">
	<div>
		<NotificationToggler
			title={$format('collapse_title_push_notifications', {
				default: 'Push Notifications',
			})}
			enabled={$user_settings.push_notifications_permissions}
			description={$format('user_push_notification_enable')}
			request={handlePushPermissions}
		/>
	</div>

	{#if $user_settings.mail_validated === 1}
		<!-- TODO change translation text to "E-mail Notifications" -->
		<div class="mt-m">
			<NotificationToggler
				title={$format('collapse_title_email_notifications', {
					default: 'Email Notifications',
				})}
				enabled={$user_settings.mail_notifications_permissions}
				description={$format('user_email_notification_enable')}
				request={handleEmailPermissions}
			/>
		</div>

		{#if !isSubUnit()}
			<div class="mt-m">
				<NotificationToggler
					title={$format('collapse_title_newsletter', {
						default: 'Newsletter',
					})}
					enabled={newsletterValue}
					description={$format('checkbox_newsletter', {
						default:
							'I want to receive exclusive deals and latest information about Shelly products and Services on my e-mail.',
					})}
					request={handleNewsletter}
				/>
			</div>
		{/if}
	{/if}

	{#if $user_settings.mail_validated === 0}
		<ConfirmEmail toastEmailValidationMessage={undefined} />
	{/if}
</Stack>

<style>
	:global(.notification-menu > :not(:last-child)) {
		border-bottom: 1px solid;
		border-color: var(--color-2);
		padding-bottom: var(--spacing-m);
	}
</style>
